import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --carl-between-row-padding: calc(30rem / var(--default-rem-px-count));
      --carl-between-column-padding: calc(24rem / var(--default-rem-px-count));
    }

    .carl-layout {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        var(--bottom-padding-height)
        [last-line];
    }

    .drivers {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      gap: var(--carl-between-row-padding) 0;
    }

    .driver-info {
      background-color: #f8f8f8;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: var(--carl-between-column-padding);
    }

    .driver-image {
      display: inherit;
      background-color: #f8f8f8;
    }

    h2 {
      margin-bottom: calc(20rem / var(--default-rem-px-count));
    }

    .eyebrow {
      color: #315470;
      font-weight: 400;
      font-size: 0.825em;
      letter-spacing: -0.24px;
      line-height: 0.825em;
      margin-bottom: calc(10rem / var(--default-rem-px-count));
    }

    .description {
      margin-bottom: calc(20rem / var(--default-rem-px-count));
    }

    img {
      width: 100%;
      margin: auto 0;
    }

    @media (min-width: 600px) {
      .drivers {
        grid-column: 3 / 13;
      }
    }

    @media (min-width: 1024px) {
      :host {
        --carl-between-row-padding: calc(40rem / var(--default-rem-px-count));
        --carl-between-column-padding: calc(
          32rem / var(--default-rem-px-count)
        );
      }

      .carl-layout {
        grid-template-rows:
          var(--top-padding-height)
          minmax(0, auto)
          var(--bottom-padding-height)
          [last-line];
      }

      .drivers {
        grid-column: 3 / 13;
        grid-row: 2;
        display: flex;
        flex-direction: column;
      }

      .driver-wrapper {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(10, minmax(0, 1fr));
        grid-template-rows: auto;
      }

      .driver-wrapper:nth-child(odd) .driver-image {
        grid-column: 1 / 7;
        grid-row: 1;
      }
      .driver-wrapper:nth-child(odd) .driver-info {
        grid-column: 7 / 11;
        grid-row: 1;
      }
      .driver-wrapper:nth-child(odd) .driver-info > * {
        margin-right: 7.5%;
      }

      .driver-wrapper:nth-child(even) .driver-image {
        grid-column: 5 / 11;
        grid-row: 1;
      }
      .driver-wrapper:nth-child(even) .driver-info {
        grid-column: 1 / 5;
        grid-row: 1;
      }
      .driver-wrapper:nth-child(even) .driver-info > * {
        margin-left: 7.5%;
      }

      h2 {
        margin-bottom: calc(20rem / var(--default-rem-px-count));
      }

      .eyebrow {
        margin-bottom: calc(10rem / var(--default-rem-px-count));
      }

      .description {
        margin-bottom: calc(30rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      :host {
        --carl-between-row-padding: calc(80rem / var(--default-rem-px-count));
        --carl-between-column-padding: calc(
          32rem / var(--default-rem-px-count)
        );
      }
    }
  `,
];
